import React, { Component } from 'react';
import { Table, message, Tag, Button, Tooltip, Form , Input} from 'antd';
import {Link} from 'react-router-dom'
import axios from 'axios'
import keys from '../../../../keys';


class ViewSales extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            loading : false,   
            search : null,
            pagination:{
                total: null,
                current : 1 ,
                pageSize : 6
            }
           
         }
    }

    fetchData = (params) =>{
        this.setState({
            loading:true
        })
        axios.get(`${keys.server}/sales/rm/orders/detailed` , {params:{invoice:"all" , ...params }})
        .then(
            response => {
                const  data = response.data.results
                const pagination = {...this.state.pagination}
                pagination.total = response.data.count
                
                console.log(response)

                this.setState({
                    data:data,
                    loading:false,
                    pagination:pagination
                } , () => console.log(this.state))
                
            }
        )
        .catch(err =>{
            message.error(err.message)
            console.error(err)
            this.setState({
                loading:false
            })
        })
    }

    componentDidMount(){
        this.fetchData({limit:this.state.pagination.pageSize})
    }

    onTableChange = (pagination) =>{
  
        this.setState({
            pagination:pagination
        }
        ,
        () =>{
            this.fetchData({
                offset: (pagination.current-1)*pagination.pageSize,
                limit: pagination.pageSize,
                search : this.state.search
            })
        }
        )
    }

    columns = [
        {
            title: 'Invoice',
            dataIndex: 'invoice_no',
            key: 'invoice',
            render : (invoice,row) => row.payment_status ==="CASH SALE" ? invoice :<Link to={`/sales/order/${row.id}`}><Button type="link">{invoice}</Button></Link>
    
          },   

          {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render : date => date.substr(0,10)
    
          },   
          
          {
            title: 'Product ID',
            dataIndex: 'order_lines',
            key: 'productId',
            render : (orderlines) => orderlines.map((ol) => <Tag color="green">{ol.product.item_code}</Tag>)
          },        
          {
            title: 'Customer',
            dataIndex: 'customer',
            key: 'customer_nic',
            render : (customer) => <Tooltip  title = {"NIC : " + customer.NIC} ><Link to={`/customers/${customer.id}`}> <Button  type="link">{customer.contact.FirstName + " " + customer.contact.LastName}</Button></Link></Tooltip>
          },  

          {
            title: 'Payment Status',
            dataIndex: 'payment_status',
            key: 'paymentStatus',
          },  
          {
            title: '',
            dataIndex: 'id',
            key: 'id',
            render : (id,row) => <Link to={`/sales/order/${id}`}><Button disabled ={row.payment_status === "CASH SALE"} >Show Order</Button></Link>
          }, 
        //   {
        //     title: '',
        //     dataIndex: 'instalment_plan_id',
        //     key: 'instalment_plan_id',
        //     render: id => <Button type="primary" icon="user" onClick={(e) => this.props.handleViewInstalmentPlan(e.target.id)} id={id}>Instalment Plan</Button>,
        //   }

    ]    

    handleSearchChange = (e) => {
        console.log(e)
        this.setState({
            search : e.target.value
        },()=>  {
            
            this.fetchData({
            offset: (this.state.pagination.current-1)*this.state.pagination.pageSize,
            limit: this.state.pagination.pageSize,
             search : this.state.search
            })
        }

        )
    }



    render() { 
        return ( 
        <>    
        <Form>
            <Form.Item labelAlign="left" labelCol={{span:2}} wrapperCol={{span:6}} label="Search">
                <Input placeholder="Invoice / Item Code / NIC" onChange={this.handleSearchChange} value={this.state.search}></Input>
            </Form.Item>
        </Form>
        <Table
            rowKey={(row=>row.invoice_no)}
            expandedRowRender = {
                record => (
                    <Table 
                        columns = {subTableColumns}
                        dataSource = {record.order_lines}
                    ></Table>
            )
            }
            columns = {this.columns}
            dataSource = {this.state.data}
            onChange = {this.onTableChange}
            pagination={this.state.pagination}
        />
        </>
        );
    }
}

const subTableColumns = [
    { title : "Item Code" , key : 0 , dataIndex : "product.item_code" },
    { title : "Product Code" , key : 1 , dataIndex : "product.batch.product.product_code" },
    { title : "Product Title" , key : 2 , dataIndex : "product.batch.product.title" },
    { title : "Unit Price" , key : 3 , dataIndex : "unit_price" }
]
 
export default ViewSales;